import { MARKETING_API } from '@/constants/API';
import { request } from '@umijs/max';

//方案列表
export async function getSchemeLis(params: string) {
  return request(`${MARKETING_API}/scheme/parameter/getSchemeList`, {
    data: {
      ...params,
      appId: process.env.appId,
    },
    method: 'post',
  });
}
